import ui from './ui'
import util from './util'
import arrays from './arrays'
import enums from './enums'
import agencias from './controllers/agencias'
import audittrail from './controllers/audittrail'
import autenticacao from './controllers/autenticacao'
import bancos from './controllers/bancos'
import bloqueiocontalote from './controllers/bloqueiocontalote'
import contas from './controllers/contas'
import finalidadestransferencia from './controllers/finalidadestransferencia'
import contacorrentistas from './controllers/contacorrentistas'
import contafavorecidos from './controllers/contafavorecidos'
import contapagadorboletos from './controllers/contapagadorboletos'
import contaOperacaoContabil from './controllers/contaoperacaocontabil'
import credito from './controllers/credito'
import correntistas from './controllers/correntistas'
import dadoscm from './controllers/dadoscm'
import enviocm from './controllers/enviocm'
import envioted from './controllers/envioted'
import enviotitulo from './controllers/enviotitulo'
import enviotransf from './controllers/enviotransf'
import enviomovmanual from './controllers/enviomovmanual'
import feriados from './controllers/feriados'
import importaarquivos from './controllers/importaarquivos'
import impressao from './controllers/impressao'
import operadores from './controllers/operadores'
import operacoes from './controllers/operacoes'
import parceiros from './controllers/parceiros'
import parceiroheaders from './controllers/parceiroheaders'
import parceirohandshakeheaders from './controllers/parceirohandshakeheaders'
import parceirosagencia from './controllers/parceiroagencias'
import parceirooperacaocontabil from './controllers/parceirooperacaocontabil'
import parceirooperacaocomissao from './controllers/parceirooperacaocomissao'
import parceirooperacaocomissaoperiodo from './controllers/parceirooperacaocomissaoperiodo'
import cep from './controllers/cep'
import dominio from './controllers/dominios'
import contasreserva from './controllers/contasreserva'
import dashboard from './controllers/dashboard'
import queueretorno from './controllers/queueretorno'
import queueenvio from './controllers/queueenvio'
import volumetria from './controllers/volumetria'
import carteiras from './controllers/carteiras'
import cedentes from './controllers/cedentes'
import cedentescarteiras from './controllers/cedentescarteiras'
import registroboleto from './controllers/registroboleto'
import baixaoperacional from './controllers/baixaoperacional'
import baixaefetiva from './controllers/baixaefetiva'
import alteracaoboleto from './controllers/alteracaoboleto'
import apiresources from './controllers/apiresources'
import apiscopes from './controllers/apiscopes'
import apisecrets from './controllers/apisecrets'
import clients from './controllers/clients'
import clientscopes from './controllers/clientscopes'
import clientsecrets from './controllers/clientsecrets'
import queuecallback from './controllers/queuecallback'
import movimento from './controllers/movimentos'
import saldobloqueado from './controllers/saldobloqueado'
import saldobloqueadohistorico from './controllers/saldobloqueadohistorico'
import schedulerregboleto from './controllers/schedulerregboleto'
import featureFlag from './controllers/featureflag'
import tipobloqueiomanual from './controllers/tipobloqueiomanual'
import cobrancaservicos1 from './controllers/cobrancaservicos1'
import splitoperacoes from './controllers/splitoperacoes'
import paramglobal from './controllers/paramglobal'
import custocontabil from './controllers/custocontabil'
import custocontabilperiodo from './controllers/custocontabilperiodo'
import custocontabiloperacao from './controllers/custocontabiloperacao'
import arquivoretornocnab from './controllers/arquivoretornocnab'
import contachavepix from './controllers/contachavepix'
import qrcodepix from './controllers/qrcodepix'
import queueretornopix from './controllers/queueretornopix'
import queueenviopix from './controllers/queueenviopix'
import recursospix from './controllers/recursospix'
import saldobloqueadodbscore from './controllers/saldobloqueadodbscore'
import lancamentosfuturos from './controllers/lancamentosfuturos'
import aprovacaotransacao from './controllers/aprovacaotransacao'
import operadoresretaguarda from './controllers/operadoresretaguarda'
import perfilfrontend from './controllers/perfilfrontend'
import perfilfrontendscopes from './controllers/perfilfrontendscopes'
import ssocadastros from './controllers/ssocadastros'
import limitecartao from './controllers/limitecartao'
import parceirosocio from './controllers/parceirosocio'
import parceiroendereco from './controllers/parceiroendereco'
import solicitacaoAprovacaoLimite from './controllers/solicitacaoAprovacaoLimite'
import integracaoparceiro from './controllers/integracaoparceiro'
import contacartao from './controllers/contacartao'
import tempospix from './controllers/tempospix'
import cadastroRestritivo from './controllers/cadastroRestritivo'
import enviodeemail from './controllers/enviodeemail'
import enviodeemaildestinatario from './controllers/enviodeemaildestinatario'
import contacartaohistorico from './controllers/contacartaohistorico'
import participantesspi from './controllers/participantesspi'
import versaoappfrontend from './controllers/versaoappfrontend'
import comissaoparceiro from './controllers/comissaoparceiro'
import cobrancarecorrente from './controllers/cobrancarecorrente'
import cobrancarecorrentemovimento from './controllers/cobrancarecorrentemovimento'
import operadorfrontend from './controllers/operadorfrontend'
import operadorfrontendconta from './controllers/operadorfrontendconta'
import operadorfrontendmfa from './controllers/operadorfrontendmfa'
import operadorretaguardamfa from './controllers/operadorretaguardamfa'
import reivindicacaochave from './controllers/reivindicacaochave'
import doacaochave from './controllers/doacaochave'
import historicoportabilidade from './controllers/historicoportabilidade'
import operadorretaguardaparceiro from './controllers/operadorretaguardaparceiro'
import protestoBoleto from './controllers/protestoBoleto'
import arquivoretorno from './controllers/arquivoretorno'
import solicitacaorelatorio from './controllers/solicitacaorelatorio'
import infracao from './controllers/infracao'
import solicitacaodevolucao from './controllers/solicitacaodevolucao'
import consultaoperacional from './controllers/consultaoperacional'
import contatransitoria from './controllers/contatransitoria'
import limiteaprovacaoconta from './controllers/limiteaprovacaoconta'
import statusservico from './controllers/statusservico'
import cnab from './controllers/cnab'
import parceirodominio from './controllers/parceirodominio'
import expbaceninstituicao from './controllers/expbaceninstituicao'
import operacoesbacen from './controllers/operacoesbacen'
import expbacencontato from './controllers/expbacencontato'
import expbacencontaamostragem from './controllers/expbacencontaamostragem'
import favorecidos from './controllers/favorecidos'
import contafavorecidoslimite from './controllers/contafavorecidoslimite'
import notificacao from './controllers/notificacao'
import limiteadicional from './controllers/limiteadicional'
import solicitacaomfaretaguarda from './controllers/solicitacaomfaretaguarda'
import limiteoperador from './controllers/limiteoperador'
import limiteoperadoradicional from './controllers/limiteoperadoradicional'
import devolucaotituloarquivo from './controllers/devolucaotituloarquivo'
import consultafavorecido from './controllers/consultafavorecido'
import limiteoperacao from './controllers/limiteoperacao'
import operadoranalisepermissoes from './controllers/operadoranalisepermissoes'
import analisecadastro from './controllers/analisecadastro'
import relacaooperadorpermissaoanalise from './controllers/relacaooperadorpermissaoanalise'
import handshake from './controllers/handshake'
import favorecidoshistorico from './controllers/favorecidoshistorico'
import solicitacaomfafisico from './controllers/solicitacaomfafisico'
import senhaeletronica from './controllers/senhaeletronica'
import migracaocontalote from './controllers/migracaocontalote'
import administradorconta from './controllers/administradorconta'
import carteiraconta from './controllers/carteiraconta'
import correntistapjsocio from './controllers/correntistapjsocio'
import templatecaf from './controllers/templatecaf'
import operadoronboarding from './controllers/operadoronboarding'
import OperadorOnboardingAssociado from './controllers/operadoronboardingassociado'
import OperadorOnboardingAssociadoSubparceiro from './controllers/operadoronboardingassociadosubparceiro'
import associadoSubparceiro from './controllers/associadoSubparceiro'
import repassesaldoconta from './controllers/repassesaldoconta'
import parceiroip from './controllers/parceiroip'
import repassesaldocontatransacional from './controllers/repassesaldocontatransacional'
import pagadoreletronico from './controllers/pagadoreletronico'
import cessaoBoleto from './controllers/cessaoboleto'
import contavinculada from './controllers/contavinculada'
import templatenotificacao from './controllers/templatenotificacao'
import parceironotificacao from './controllers/parceironotificacao'
import operadorfrontendcategorianotificacao from './controllers/operadorfrontendcategorianotificacao'
import operadorfrontendcontanotificacao from './controllers/operadorfrontendcontanotificacao'
import subparceiro from './controllers/subparceiro'
import operadorRetaguardaSubparceiro from './controllers/operadorRetaguardaSubparceiro'
import subparceiroConta from './controllers/subparceiroconta'
import monitoradda from './controllers/monitoradda'
import antifraudes from './controllers/antifraudes'
import solicitacaoccs from './controllers/solicitacaoccs'
import arquivotransacaomulticontas from './controllers/arquivoTransacaoMultiContas'
import cadastrofavorecidolotearquivo from './controllers/cadastrofavorecidolotearquivo'
import cadastrofavorecidolotearquivolinha from './controllers/cadastrofavorecidolotearquivolinha'
import operadorfrontendbloqueiovinculo from './controllers/operadorfrontendbloqueiovinculo'
import quiz from './controllers/quiz'
import operadorfrontendcontaexcecaohorario from './controllers/operadorfrontendcontaexcecaohorario'
import parametrizacaoalertafraude from './controllers/parametrizacaoalertafraude'
import antifraudelistapositiva from './controllers/antifraudelistapositiva'
import onboardingContas from './controllers/onboardingContas'
import analisesOnboarding from './controllers/analisesOnboarding'
import antifraudelistapositivaexclusao from './controllers/antifraudelistapositivaexclusao'
import configuracaoAntifraude from './controllers/configuracaoantifraude'
import parceiroloja from './controllers/parceiroloja'
import cadastromenordeidade from './controllers/cadastromenordeidade'
import monitorrelatorioconsolidadocredito from './controllers/monitorrelatorioconsolidadocredito'
import restricoescontratacao from './controllers/restricoescontratacao'
import marcacaofraude from './controllers/marcacaofraude'
import protegemais from './controllers/protegemais'
import permissaoliberacaoespecial from './controllers/permissaoliberacaoespecial'
import operadorcms from './controllers/operadorcms'
import recuperacaovalores from './controllers/recuperacaovalores'

const api = {
  UI: ui,
  UTIL: util,
  Arrays: arrays,
  Enums: enums,
  Agencias: agencias,
  Antifraudes: antifraudes,
  AuditTrail: audittrail,
  Autenticacao: autenticacao,
  Bancos: bancos,
  BloqueioContaLote: bloqueiocontalote,
  ProtestoBoleto: protestoBoleto,
  Contas: contas,
  ContaCorrentistas: contacorrentistas,
  Finalidadestransferencia: finalidadestransferencia,
  ContaFavorecidos: contafavorecidos,
  ContaPagadorBoletos: contapagadorboletos,
  ContaOperacaoContabil: contaOperacaoContabil,
  Credito: credito,
  Correntistas: correntistas,
  SaldoBloqueadoDBSCore: saldobloqueadodbscore,
  DadosCM: dadoscm,
  EnvioCM: enviocm,
  EnvioTed: envioted,
  EnvioTitulo: enviotitulo,
  EnvioTransf: enviotransf,
  EnvioMovManual: enviomovmanual,
  Feriados: feriados,
  ImportaArquivos: importaarquivos,
  Impressao: impressao,
  Operadores: operadores,
  OperadoresRetaguarda: operadoresretaguarda,
  Operacoes: operacoes,
  Parceiros: parceiros,
  ParceirosAgencias: parceirosagencia,
  ParceiroSocio: parceirosocio,
  ParceiroEndereco: parceiroendereco,
  ParceiroHeaders: parceiroheaders,
  ParceiroHandshakeHeaders: parceirohandshakeheaders,
  ParceiroOperacaoContabil: parceirooperacaocontabil,
  ParceiroOperacaoComissao: parceirooperacaocomissao,
  ParceiroOperacaoComissaoPeriodo: parceirooperacaocomissaoperiodo,
  ViaCEP: cep,
  Dominio: dominio,
  ContasReserva: contasreserva,
  Dashboard: dashboard,
  QueueRetorno: queueretorno,
  QueueEnvio: queueenvio,
  Volumetria: volumetria,
  Carteiras: carteiras,
  Cedentes: cedentes,
  CedentesCarteiras: cedentescarteiras,
  RegistroBoleto: registroboleto,
  ArquivoTransacaoMultiContas: arquivotransacaomulticontas,
  BaixaOperacional: baixaoperacional,
  BaixaEfetiva: baixaefetiva,
  AlteracaoBoleto: alteracaoboleto,
  ApiResources: apiresources,
  ApiScopes: apiscopes,
  ApiSecrets: apisecrets,
  Clients: clients,
  ClientScopes: clientscopes,
  ClientSecrets: clientsecrets,
  QueueCallback: queuecallback,
  Movimento: movimento,
  SaldoBloqueado: saldobloqueado,
  SaldoBloqueadoHistorico: saldobloqueadohistorico,
  SchedulerRegBoleto: schedulerregboleto,
  FeatureFlag : featureFlag,
  TipoBloqueioManual: tipobloqueiomanual,
  CobrancaServicos1: cobrancaservicos1,
  SplitOperacoes: splitoperacoes,
  ParamGlobal: paramglobal,
  CustoContabil: custocontabil,
  CustoContabilPeriodo: custocontabilperiodo,
  CustoContabilOperacao: custocontabiloperacao,
  ArquivoRetornoCNAB: arquivoretornocnab,
  ContaChavePix: contachavepix,
  QRCodePix: qrcodepix,
  QueueRetornoPix: queueretornopix,
  QueueEnvioPix: queueenviopix,
  RecursosPix: recursospix,
  PerfilFrontEnd: perfilfrontend,
  PerfilFrontEndScopes: perfilfrontendscopes,
  SSOCadastros: ssocadastros,
  IntegracaoParceiro: integracaoparceiro,
  SolicitacaoAprovacaoLimite: solicitacaoAprovacaoLimite,
  LimiteCartao: limitecartao,
  ContaCartao: contacartao,
  TemposPix: tempospix,
  LancamentosFuturos: lancamentosfuturos,
  AprovacaoTransacao: aprovacaotransacao,
  CadastroRestritivo: cadastroRestritivo,
  EnvioDeEmail: enviodeemail,
  EnvioDeEmailDestinatario: enviodeemaildestinatario,
  ContaCartaoHistorico: contacartaohistorico,
  VersaoAppFrontend: versaoappfrontend,
  ComissaoParceiro: comissaoparceiro,
  CobrancaRecorrente: cobrancarecorrente,
  CobrancaRecorrenteMovimento: cobrancarecorrentemovimento,
  OperadorFrontEnd: operadorfrontend,
  OperadorFrontEndConta: operadorfrontendconta,
  OperadorOnboarding: operadoronboarding,
  ParticipantesSpi: participantesspi,
  OperadorFrontEndMfa: operadorfrontendmfa,
  OperadorRetaguardaMfa: operadorretaguardamfa,
  OperadorRetaguardaParceiro: operadorretaguardaparceiro,
  ArquivoRetorno: arquivoretorno,
  DoacaoChave: doacaochave,
  ReivindicacaoChave: reivindicacaochave,
  HistoricoPortabilidade: historicoportabilidade,
  SolicitacaoRelatorio: solicitacaorelatorio,
  ContaTransitoria: contatransitoria,
  Infracao: infracao,
  SolicitacaoDevolucao: solicitacaodevolucao,
  ParceiroDominio: parceirodominio,
  StatusServico: statusservico,
  Notificacao: notificacao,
  ConsultaOperacional: consultaoperacional,
  Favorecidos: favorecidos,
  Contafavorecidoslimite: contafavorecidoslimite,
  ExpBACENInstituicao: expbaceninstituicao,
  ExpBACENContaAmostragem: expbacencontaamostragem,
  ExpBACENContato: expbacencontato,
  OperacoesBacen: operacoesbacen,
  OperadorOnboardingAssociado: OperadorOnboardingAssociado,
  OperadorOnboardingAssociadoSubparceiro:
  OperadorOnboardingAssociadoSubparceiro,
  associadoSubparceiro: associadoSubparceiro,
  LimiteAdicional: limiteadicional,
  ConsultaFavorecidos: consultafavorecido,
  SolicitacaoMfaRetaguarda: solicitacaomfaretaguarda,
  LimiteOperador: limiteoperador,
  LimiteOperadorAdicional: limiteoperadoradicional,
  LimiteAprovacaoConta: limiteaprovacaoconta,
  Cnab: cnab,
  DevolucaoTituloArquivo: devolucaotituloarquivo,
  LimiteOperacao: limiteoperacao,
  OperadorAnalisePermissoes: operadoranalisepermissoes,
  AnaliseCadastro: analisecadastro,
  RelacaoOperadorPermissaoAnalise: relacaooperadorpermissaoanalise,
  Handshake: handshake,
  FavorecidosHistorico: favorecidoshistorico,
  SolicitacaoMfaFisico: solicitacaomfafisico,
  SenhaEletronica: senhaeletronica,
  MigracaoContaLote: migracaocontalote,
  AdministradorConta: administradorconta,
  CarteiraConta: carteiraconta,
  CorrentistaPJSocio: correntistapjsocio,
  TemplateCAF: templatecaf,
  ContaVinculada: contavinculada,
  RepasseSaldoConta: repassesaldoconta,
  ParceiroIp: parceiroip,
  RepasseSaldoContaTransacional: repassesaldocontatransacional,
  PagadorEletronico: pagadoreletronico,
  CessaoBoleto: cessaoBoleto,
  TemplateNotificacao: templatenotificacao,
  ParceiroNotificacao: parceironotificacao,
  OperadorFrontEndCategoriaNotificacao: operadorfrontendcategorianotificacao,
  OperadorFrontEndContaNotificacao: operadorfrontendcontanotificacao,
  Subparceiro: subparceiro,
  OperadorRetaguardaSubparceiro: operadorRetaguardaSubparceiro,
  SubparceiroConta: subparceiroConta,
  MonitorADDA: monitoradda,
  SolicitacaoCCS: solicitacaoccs,
  CadastroFavorecidoLoteArquivo: cadastrofavorecidolotearquivo,
  CadastroFavorecidoLoteArquivoLinha: cadastrofavorecidolotearquivolinha,
  OperadorFrontEndBloqueioVinculo: operadorfrontendbloqueiovinculo,
  Quiz: quiz,
  OperadorFrontEndContaExcecaoHorario: operadorfrontendcontaexcecaohorario,
  ParametrizacaoAlertaFraude: parametrizacaoalertafraude,
  OnboardingContas: onboardingContas,
  AnalisesOnboarding: analisesOnboarding,
  AntifraudeListaPositiva: antifraudelistapositiva,
  AntifraudeListaPositivaExclusao: antifraudelistapositivaexclusao,
  ConfiguracaoAntifraude: configuracaoAntifraude,
  ParceiroLoja: parceiroloja,
  CadastroMenorDeIdade: cadastromenordeidade, 
  MonitorRelatorioConsolidadoCredito: monitorrelatorioconsolidadocredito,
  RestricoesContratacao: restricoescontratacao,
  MarcacaoFraude: marcacaofraude,
  ProtegeMais: protegemais,
  PermissaoLiberacaoEspecial: permissaoliberacaoespecial,
  OperadorCMS: operadorcms,
  RecuperacaoValores: recuperacaovalores,
}

export default api
